module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-18-bd39a5527956f0e97e374ee25c3cf90d.jpg";